import { 
    apiRequest,
    strukturOrganisasiDraft,
    strukturOrganisasiSubmitDraft,
    strukturOrganisasiInactiveDraft
} from "../../../../../services/adapters/base"

class DraftRepository {
    fetchDraft = async (query, cancelToken) => {
        return await apiRequest('get', strukturOrganisasiDraft, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

    fetchSubmit = async (query, cancelToken) => {
        return await apiRequest('post', strukturOrganisasiSubmitDraft, {
            body: query,
            cancelToken: cancelToken
        }, true)
    }
    
    fetchInactive = async (query) => {
        return await apiRequest("post", strukturOrganisasiInactiveDraft, {
            body: query
        }, true)
    }
}

export default DraftRepository
